// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__1Mfw3","header":"sidebar_header__3fLQp","body":"sidebar_body__1ld9c","footer":"sidebar_footer__1PUCx"};